<template>
    <v-container fluid class="pa-0 pb-8">
        <v-container class="container-custom">
            <Breadcrumbs
                :title="$t('modules.portalalumno.employment_portals.breadcrumbs.title')"
                :description="$t('modules.portalalumno.employment_portals.breadcrumbs.description')"
            ></Breadcrumbs>
            <v-row justify="center" justify-lg="start" class="mt-8">
                <v-card
                    v-for="portal in portals"
                    :key="portal.id"
                    :href="portal.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    elevation="2"
                    outlined
                    width="280"
                    min-height="190"
                    class="portal-card mx-2 mb-5 d-flex align-center"
                    @click="trackClick(portal)"
                >
                    <v-container class="d-flex flex-column justify-center align-center">
                        <img :src="portal.logo" :alt="portal.name" class="portal-logo">
                        <span class="text-lg-h6 mt-4 text-center primary--text">{{ portal.name }}</span>
                        <span class="caption mt-1 text-center">
                            {{ $t('modules.portalalumno.employment_portals.label.go_to_portal') }}
                            <v-icon x-small color="primary">mdi-open-in-new</v-icon>
                        </span>
                    </v-container>
                </v-card>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import randstadLogo from '@/assets/images/portalalumno/randstad-logo.svg'
import adeccoLogo from '@/assets/images/portalalumno/adecco-logo.svg'

export default {
    name: 'EmploymentPortalsView',
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            portals: [
                {
                    id: 'randstad',
                    name: 'Randstad',
                    logo: randstadLogo,
                    url: 'https://www.randstad.es/candidatos/ofertas-empleo/',
                },
                {
                    id: 'adecco',
                    name: 'Adecco',
                    logo: adeccoLogo,
                    url: 'https://www.adecco.com/es-es',
                },
            ],
        }
    },
    methods: {
        trackClick(portal) {
            this.$trackEvent('Portales de Empleo', portal.name, 'Clic portal')
        },
    },
}
</script>

<style lang="sass" scoped>
    .portal-card:hover
        cursor: pointer
        background-color: #eee

    .portal-logo
        height: 70px
        max-width: 100%
        object-fit: contain
</style>
